import { Message, MessageBox } from 'element-ui';
import Fetch from '@/api';

const state = {
  searchParams: {},
  pageNo: 1,
  pageSize: 12,
  total: 0,
  punchList: []
};

const mutations = {
  SET_PUNCH_LIST(state, { data, pageNo, totalCount }) {
    state.punchList = data;
    state.pageNo = pageNo;
    state.total = totalCount;
  },
  SET_PUNCH_PARAM(state, searchParams) {
    state.searchParams = searchParams;
  }
};

const actions = {
  async fetchPunchList({ commit, state }, params = {}) {
    const { pageSize, searchParam } = state;
    const res = await Fetch.punch_page_query({ page: 1, pageSize, ...searchParam, ...params });
    commit('SET_PUNCH_PARAM', params);
    commit('SET_PUNCH_LIST', res);
  },
  async punchInAndOut({ dispatch }) {
    // 调起人脸识别
    const recognition = () =>
      import(
        /* webpackChunkName:'punchModal' */
        /* webpackPreload: true */
        '@/pages/punch/components/punchModal'
      ).then(({ default: punchModal }) => {
        punchModal.show({
          success: (image, context) => {
            return Fetch.punch(image).then(({ code, punchType, punchTime }) => {
              if (code === 200) {
                // 打卡成功
                if (punchType === 1) {
                  context.remark = `上班打卡成功 ${punchTime}`;
                  context.status = 'recognized';
                } else if (punchType === 2) {
                  context.remark = `下班打卡成功 ${punchTime}`;
                  context.status = 'recognized';
                }

                dispatch('global/SETpunchState', null, { root: true });

                return true;
              } else {
                // 打卡失败
                return false;
              }
            });
          },
          successCallback: null,
          successDelayDuration: 4000
        });
      });

    Fetch.before_punch().then(code => {
      switch (code) {
        case 200:
          // 校验通过
          recognition();
          break;
        case 300:
          // 上班打卡后5分钟之内不能打卡
          Message.info('上下班时间间隔不足5分钟，请5分钟后再试');
          break;
        case 400:
          // 未满8小时打卡提示
          MessageBox.confirm('当前上班时长未满8小时，是否要下班打卡?', '未满8小时', {
            center: true,
            confirmButtonText: '仍要打卡',
            cancelButtonText: '取消',
            showClose: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            beforeClose(action, instance, done) {
              switch (action) {
                case 'confirm':
                  done();
                  recognition();
                  break;
                case 'cancel':
                case 'close':
                  done();
                  break;
              }
            }
          });
          break;
        case 500:
          Message.info('您已经打过下班的卡了');
          break;
        default: {
          // todo
        }
      }
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
